import React from "react";
import {GatsbyImage} from "gatsby-plugin-image";

const FiftyFiftyHorizontal = (
  {
    className = "",
    mediaPosition = "right",
    contentColumns = 4,
    contentOffset = 0,
    mediaColumns = 7,
    mediaOffset = 1,
    imageData = null,
    children
  }
) => {
  return (
    <section className={`fifty-fifty-h ${className}`}>
      <div className="container">
        <div className="row align-items-center">
          <div className={`col-12 order-1 col-lg-${contentColumns} offset-lg-${contentOffset}`}>
            <div className="fifty-fifty-h__content-wrapper">
              {children}
            </div>
          </div>
          <div className={`col-12 order-2 col-lg-${mediaColumns} offset-lg-${mediaOffset} ${mediaPosition === 'left' ? 'order-lg-0' : ''}`}>
            <div className="fifty-fifty-h__media-wrapper">
              <GatsbyImage
                className="fifty-fifty-h__image"
                image={imageData}
                alt="Evo"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FiftyFiftyHorizontal
